import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "addressOption",
    "addAddressFields",
    "addressLine1",
    "addressLine2",
    "city",
    "state",
    "zipcode",
    "generateButton",
    "validationPanel",
    "validationMessage"
  ];

  connect() {
    this.setSelectedOption();
  }

  async showQuickLook(event) {
    event.preventDefault();

    const pupilToken = this.data.get("pupilToken");
    const docType = this.data.get("docType");
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
  
    const response = await fetch(`/schools/pupils/${pupilToken}/documents/${docType}/quick-look`, {
      method: "GET",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": csrfToken,
        "Accept": "text/vnd.turbo-stream.html"
      }
    });

    if (response.ok) {
      const quickViewElement = document.querySelector("#driving-school-document-quick-look");
      quickViewElement.classList.remove("u-hidden");

      const responseBody = await response.text();
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(responseBody, "text/html");
      const template = xmlDoc.querySelector("template");
      const targetElement = quickViewElement;

      if (template && targetElement) {
        targetElement.innerHTML = "";
        targetElement.appendChild(template.content.cloneNode(true));
      }
    }
  }

  closeQuickLook(event) {
    event.preventDefault();

    const quickViewElement = document.querySelector("#driving-school-document-quick-look");
    quickViewElement.classList.add("u-hidden");
  }

  setSelectedOption() {
    const radioOptions = this.addressOptionTargets || [];
    const checked = radioOptions.find(r => r.checked);
    const selectedValue = checked ? (checked.value || "") : "";

    if (this.hasGenerateButtonTarget) {
      this.generateButtonTarget.disabled = (selectedValue === "");
    }
    if (this.hasAddAddressFieldsTarget) {
      this.addAddressFieldsTarget.disabled = (selectedValue !== "");
    }

    if (selectedValue === "" && this.hasAddAddressFieldsTarget) {
      this.addAddressFieldsTarget.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  disableGenerateButton() {
    this.element.textContent = "Generating...";
    this.element.style.pointerEvents = "none";
    this.element.classList.add("Button--disabled");
  }

  validateForm() {
    let validationErrors = [];
    const requiredFields = [
      {
        target: this.addressLine1Target,
        name: "Address line 1",
      },
      {
        target: this.zipcodeTarget,
        name: "Zipcode",
      },
    ];

    requiredFields.forEach((field_data) => {
      let field = field_data.target;

      if (field) {
        if (field.value.trim() === "") {
          validationErrors.push(`${field_data.name} cannot be empty.`);
        }
        if (
          field_data.target == this.zipcodeTarget &&
          field.value.trim().length != 5
        ) {
          validationErrors.push(`${field_data.name} must be 5 numbers.`);
        }
      }
    });

    return validationErrors;
  }

  async addAddress(event) {
    const errors = this.validateForm();
    
    if (errors.length > 0) {
      event.preventDefault();
      const validationPanel = this.validationPanelTarget;
      const validationMessage = this.validationMessageTarget;
      validationMessage.innerHTML = errors.join("<br>");
      validationPanel.hidden = false;
      validationMessage.hidden = false;
      return;
    }
  }

  generateDocument(event) {
    if (this.hasGenerateButtonTarget) {
      this.generateButtonTarget.disabled = true;
      this.generateButtonTarget.textContent = "Generating...";
    }

    const quickViewElement = document.querySelector("#driving-school-document-quick-look");
    quickViewElement.classList.add("u-hidden");
  }

  scrollToTop(event) {
    if (event.detail.success) {
      const quickLook = document.getElementById("documents-quick-look");
    
      if (quickLook) {
        quickLook.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  }
}